import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1633375b&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1633375b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhishengluo/opp-scratch/scratch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1633375b')) {
      api.createRecord('1633375b', component.options)
    } else {
      api.reload('1633375b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1633375b&scoped=true&", function () {
      api.rerender('1633375b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/classroom1/index.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/classroom1/index.vue
// module id = ebq5
// module chunks = 0